import type { Notifier } from '@airbrake/browser';

type AirbrakeLike = Pick<Notifier, 'notify' | 'addFilter'>;

let airbrakeInstance: AirbrakeLike | null = null;

/** Pinia store 等、inject が使えない場所向けに main.ts から登録する */
export const setAirbrake = (instance: AirbrakeLike) => {
  airbrakeInstance = instance;
};

export const getAirbrake = (): AirbrakeLike | null => airbrakeInstance;
